import {
  GET_WORKERS_FAILURE,
  GET_WORKERS_REQUEST,
  GET_WORKERS_SUCCESS,
} from "./ActionType";

const initialState = {
  workers: [],
  loading: false,
  error: null,
};

export const workerReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_WORKERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_WORKERS_SUCCESS:
      return {
        ...state,
        workers: action.payload,
        loading: false,
        error: null,
      };
    case GET_WORKERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
